export const BACKEND_URL = process.env.REACT_APP_HOST!.split('/api')[0]
